<template>
    <div class="d-flex justify-content-end align-items-center w-100 pt-2 pb-1">
        <div>
            <slot name="new-key-result-btn" />
        </div>
        <div class="ml-3">
            <slot name="toggle-key-results-btn" />
        </div>
        <div class="ml-3">
            <slot name="okrs-chart-btn" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ButtonsContainer',
}
</script>
